import { atom } from "recoil";

// A user experience determines if certain ui/ux is shown to the user. It's a method
// for supporting one time user journeys, like a Get Started tour or a prompt with a
// Don't Ask Me Again option. Once the user completes the intended action the
// experience state is toggled.
//
// User experiences are saved in the db, but since we want the user to repeat
// the experience every time they return to the app, storing it in a recoil state will
// provide session based expeiences.

type SessionExperiences = {
  skippedConnectBankAccount: boolean;
};

// Stores completed user expeiences that reset when a user returns to the app
export const sessionExperiencesState = atom<SessionExperiences>({
  key: "sessionExperiences",
  default: {
    skippedConnectBankAccount: false,
  },
});
